
import { useState, useEffect } from 'react';
// 修复undefined数组错误 - 2024-10-15
import Navbar from '../../components/feature/Navbar';
import Card from '../../components/base/Card';
import Button from '../../components/base/Button';
import Modal from '../../components/base/Modal';
import Input from '../../components/base/Input';
import { supabaseService } from '../../utils/supabase';

interface PersonalInfo {
  name: string;
  title: string;
  email: string;
  location: string;
  summary: string;
  skills: string[];
  languages: string[];
  avatar?: string;
}

interface EducationItem {
  id: string;
  school: string;
  degree: string;
  major: string;
  startDate: string;
  endDate: string;
  description: string;
  gpa?: string;
  image?: string;
}

interface ExperienceItem {
  id: string;
  company: string;
  position: string;
  startDate: string;
  endDate: string;
  description: string;
  achievements: string[];
  image?: string;
}

interface ProjectItem {
  id: string;
  name: string;
  description: string;
  technologies: string[];
  startDate: string;
  endDate: string;
  github?: string;
  demo?: string;
  highlights: string[];
  image?: string;
}

interface PaperItem {
  id: string;
  title: string;
  journal: string;
  date: string;
  authors: string;
  abstract: string;
  keywords: string[];
  url?: string;
  image?: string;
}

interface AdminData {
  personalInfo: PersonalInfo;
  education: EducationItem[];
  experience: ExperienceItem[];
  projects: ProjectItem[];
  papers: PaperItem[];
  homeImages?: string[];
}

export default function Admin() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [loginForm, setLoginForm] = useState({ username: '', password: '' });
  const [activeTab, setActiveTab] = useState('personal');
  const [showModal, setShowModal] = useState(false);
  const [editingItem, setEditingItem] = useState<any>(null);
  const [editingType, setEditingType] = useState<string>('');
  const [loading, setLoading] = useState(false);
  const [saveStatus, setSaveStatus] = useState<'idle' | 'saving' | 'success' | 'error'>('idle');

  const [adminData, setAdminData] = useState<AdminData>({
    personalInfo: {
      name: '李明',
      title: '计算机科学与技术应届毕业生',
      email: 'liming@example.com',
      location: '北京市海淀区',
      summary:
        '即将毕业的计算机科学与技术专业学生，在校期间积极参与各类项目实践和实习，掌握多种编程语言和开发框架。具备扎实的理论基础和实践经验，热爱技术创新，渴望在软件开发领域开启职业生涯，为企业创造价值。',
      skills: [],
      languages: [],
      avatar:
        'https://readdy.ai/api/search-image?query=Young%20fresh%20graduate%20student%20in%20casual%20business%20attire%2C%20confident%20smile%2C%20university%20campus%20background%2C%20natural%20lighting%2C%20professional%20headshot%20photography%20for%20job%20applications&width=400&height=400&seq=graduate_avatar&orientation=squarish',
    },

    education: [
      {
        id: '1',
        school: '北京理工大学',
        degree: '本科',
        major: '计算机科学与技术',
        startDate: '2020-09',
        endDate: '2024-06',
        description:
          '主修计算机科学与技术专业，学习了数据结构、算法设计、操作系统、数据库系统等核心课程。',
        gpa: '3.8/4.0',
      },
      {
        id: '2',
        school: '北京市第一中学',
        degree: '高中',
        major: '理科',
        startDate: '2017-09',
        endDate: '2020-06',
        description:
          '高中阶段专注理科学习，数学、物理成绩优异，为大学专业学习打下坚实基础。',
        gpa: '',
      },
    ],
    experience: [
      {
        id: '1',
        company: '腾讯科技',
        position: '前端开发实习生',
        startDate: '2023-07',
        endDate: '2023-09',
        description: '参与微信小程序开发，负责用户界面设计和交互功能实现。',
        achievements: ['完成3个小程序页面开发', '优化页面加载速度30%', '获得导师好评'],
      },
      {
        id: '2',
        company: '字节跳动',
        position: '后端开发实习生',
        startDate: '2023-01',
        endDate: '2023-03',
        description: '参与抖音后台系统开发，学习大规模分布式系统架构。',
        achievements: ['参与API接口开发', '学习Redis缓存优化', '完成单元测试编写'],
      },
    ],
    projects: [
      {
        id: '1',
        name: '在线学习管理系统',
        description:
          '基于Spring Boot和React开发的在线学习平台，支持课程管理、作业提交、成绩查询等功能。',
        technologies: ['Spring Boot', 'React', 'MySQL', 'Redis'],
        startDate: '2023-03',
        endDate: '2023-06',
        github: 'https://github.com/liming/learning-system',
        demo: 'https://learning-demo.com',
        highlights: ['支持1000+并发用户', '实现实时消息推送', '获得校级优秀项目奖'],
      },
      {
        id: '2',
        name: '智能推荐系统',
        description: '基于协同过滤算法的图书推荐系统，为用户推荐感兴趣的书籍。',
        technologies: ['Python', 'Django', 'Pandas', 'Scikit-learn'],
        startDate: '2022-09',
        endDate: '2022-12',
        github: 'https://github.com/liming/book-recommendation',
        demo: '',
        highlights: ['推荐准确率达85%', '处理10万+图书数据', '用户满意度4.5/5'],
      },
    ],
    papers: [
      {
        id: '1',
        title: '基于深度学习的图像识别算法研究',
        journal: '毕业论文',
        date: '2024-05',
        authors: '李明',
        abstract:
          '本文研究了基于卷积神经网络的图像识别算法，通过改进网络结构和训练方法，提高了图像分类的准确率。实验结果表明，改进后的算法在CIFAR-10数据集上的准确率达到95.2%。',
        keywords: ['深度学习', '图像识别', '卷积神经网络', '计算机视觉'],
        url: 'https://example.com/paper1.pdf',
      },
      {
        id: '2',
        title: '分布式系统中的数据一致性研究',
        journal: '计算机系统课程论文',
        date: '2023-12',
        authors: '李明, 张三',
        abstract:
          '本文分析了分布式系统中数据一致性的挑战，比较了不同一致性协议的优缺点，并提出了一种基于Raft算法的改进方案。',
        keywords: ['分布式系统', '数据一致性', 'Raft算法', '容错性'],
        url: 'https://example.com/paper2.pdf',
      },
    ],
    homeImages: [],
  });

  // 从 Supabase 加载数据，并在管理员登录后安全迁移旧 Base64 图片
  const loadDataFromSupabase = async () => {
    setLoading(true);
    try {
      const migration = await supabaseService.migrateLegacyImages();
      if (migration.migrated > 0) {
        console.log('已迁移 ' + migration.migrated + ' 张旧图片到 Supabase Storage');
      }
      if (migration.failed > 0) {
        console.warn(migration.failed + ' 张旧图片迁移失败，请检查 Storage bucket 和访问策略');
      }

      const data = await supabaseService.getAllData();
      setAdminData(data);
      localStorage.removeItem('adminData');
    } catch (error) {
      console.error('从 Supabase 加载数据失败:', error);
    } finally {
      setLoading(false);
    }
  };

  // 保存数据到 Supabase；不再把整份图片数据复制到 localStorage
  const saveDataToSupabase = async (newData: AdminData) => {
    setSaveStatus('saving');
    try {
      const success = await supabaseService.saveAllData(newData);
      if (!success) {
        throw new Error('保存到 Supabase 失败');
      }

      setAdminData(newData);
      localStorage.removeItem('adminData');
      setSaveStatus('success');
    } catch (error) {
      console.error('保存数据到 Supabase 失败:', error);
      setSaveStatus('error');
    } finally {
      setTimeout(() => {
        setSaveStatus('idle');
      }, 3000);
    }
  };

  const handleLogin = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    try {
      // 管理员登录验证
      if (loginForm.username === 'qiuyating' && loginForm.password === 'YT_qiu2018') {
        setIsAuthenticated(true);
        localStorage.setItem('admin_token', 'demo_token');
        await loadDataFromSupabase();
      } else {
        alert('用户名或密码错误');
      }
    } catch (error) {
      console.error('登录失败:', error);
      alert('登录失败，请检查网络连接');
    } finally {
      setLoading(false);
    }
  };

  const handleLogout = () => {
    setIsAuthenticated(false);
    localStorage.removeItem('admin_token');
  };

  const handleEditPersonalInfo = () => {
    setEditingItem(adminData.personalInfo);
    setEditingType('personal');
    setShowModal(true);
  };

  const handleEditEducation = (item?: EducationItem) => {
    setEditingItem(
      item || {
        id: Date.now().toString(),
        school: '',
        degree: '',
        major: '',
        startDate: '',
        endDate: '',
        description: '',
        gpa: '',
        image: '',
      },
    );
    setEditingType('education');
    setShowModal(true);
  };

  const handleEditExperience = (item?: ExperienceItem) => {
    setEditingItem(
      item || {
        id: Date.now().toString(),
        company: '',
        position: '',
        startDate: '',
        endDate: '',
        description: '',
        achievements: [''],
        image: '',
      },
    );
    setEditingType('experience');
    setShowModal(true);
  };

  const handleEditProject = (item?: ProjectItem) => {
    setEditingItem(
      item || {
        id: Date.now().toString(),
        name: '',
        description: '',
        technologies: [''],
        startDate: '',
        endDate: '',
        github: '',
        demo: '',
        highlights: [''],
        image: '',
      },
    );
    setEditingType('project');
    setShowModal(true);
  };

  const handleEditPaper = (item?: PaperItem) => {
    setEditingItem(
      item || {
        id: Date.now().toString(),
        title: '',
        journal: '',
        date: '',
        authors: '',
        abstract: '',
        keywords: [''],
        url: '',
        image: '',
      },
    );
    setEditingType('paper');
    setShowModal(true);
  };

  // 保存编辑
  const handleSave = async () => {
    const newData = { ...adminData };
    switch (editingType) {
      case 'personal':
        newData.personalInfo = editingItem;
        break;
      case 'education': {
        const eduIndex = newData.education.findIndex((item) => item.id === editingItem.id);
        if (eduIndex >= 0) {
          newData.education[eduIndex] = editingItem;
        } else {
          newData.education.push(editingItem);
        }
        break;
      }
      case 'experience': {
        const expIndex = newData.experience.findIndex((item) => item.id === editingItem.id);
        if (expIndex >= 0) {
          newData.experience[expIndex] = editingItem;
        } else {
          newData.experience.push(editingItem);
        }
        break;
      }
      case 'project': {
        const projIndex = newData.projects.findIndex((item) => item.id === editingItem.id);
        if (projIndex >= 0) {
          newData.projects[projIndex] = editingItem;
        } else {
          newData.projects.push(editingItem);
        }
        break;
      }
      case 'paper': {
        const paperIndex = newData.papers.findIndex((item) => item.id === editingItem.id);
        if (paperIndex >= 0) {
          newData.papers[paperIndex] = editingItem;
        } else {
          newData.papers.push(editingItem);
        }
        break;
      }
    }
    await saveDataToSupabase(newData);
    setShowModal(false);
    setEditingItem(null);
    setEditingType('');
  };

  // 删除项目
  const handleDelete = async (type: string, id: string) => {
    if (confirm('确定要删除这项内容吗？')) {
      const newData = { ...adminData };
      switch (type) {
        case 'education':
          newData.education = newData.education.filter((item) => item.id !== id);
          break;
        case 'experience':
          newData.experience = newData.experience.filter((item) => item.id !== id);
          break;
        case 'project':
          newData.projects = newData.projects.filter((item) => item.id !== id);
          break;
        case 'paper':
          newData.papers = newData.papers.filter((item) => item.id !== id);
          break;
      }
      await saveDataToSupabase(newData);
    }
  };

  // 先把文件并发上传到 Storage，再一次性保存 URL，避免多图互相覆盖
  const handleHomeImageUpload = async (files: FileList) => {
    const fileArray = Array.from(files);
    if (fileArray.some((file) => file.size > 5 * 1024 * 1024)) {
      alert('每张图片大小不能超过5MB');
      return;
    }

    try {
      setSaveStatus('saving');
      const uploadedUrls = await Promise.all(
        fileArray.map((file) => supabaseService.uploadImage(file, 'home')),
      );
      const newData = {
        ...adminData,
        homeImages: [...(adminData.homeImages || []), ...uploadedUrls],
      };
      await saveDataToSupabase(newData);
    } catch (error) {
      console.error('图片上传失败:', error);
      setSaveStatus('error');
      alert(error instanceof Error ? error.message : '图片上传失败，请稍后重试');
    }
  };

  const handleEditorImageUpload = async (file: File) => {
    try {
      const imageUrl = await supabaseService.uploadImage(file, editingType || 'misc');
      setEditingItem((current: any) => ({ ...current, image: imageUrl }));
    } catch (error) {
      console.error('图片上传失败:', error);
      alert(error instanceof Error ? error.message : '图片上传失败，请稍后重试');
    }
  };

  // 删除主页图片
  const handleDeleteHomeImage = async (index: number) => {
    const newData = { ...adminData };
    if (newData.homeImages) {
      newData.homeImages.splice(index, 1);
      await saveDataToSupabase(newData);
    }
  };

  const tabs = [
    { id: 'personal', name: '个人信息', icon: 'ri-user-line' },
    { id: 'education', name: 'Experience', icon: 'ri-graduation-cap-line' },
    { id: 'experience', name: 'Service', icon: 'ri-briefcase-line' },
    { id: 'projects', name: '项目作品', icon: 'ri-code-box-line' },
    { id: 'papers', name: '学术成果', icon: 'ri-file-text-line' },
  ];

  useEffect(() => {
    const token = localStorage.getItem('admin_token');
    if (token) {
      setIsAuthenticated(true);
      loadDataFromSupabase();
    }
  }, []);

  if (!isAuthenticated) {
    return (
      <div className="min-h-screen flex items-center justify-center" style={{background: 'linear-gradient(135deg, #64748b, #cbd5e1)'}}>
        <Card className="w-full max-w-md p-8" glass>
          <div className="text-center mb-8">
            <div className="w-16 h-16 bg-gradient-to-r from-blue-500 to-purple-500 rounded-full flex items-center justify-center mx-auto mb-4">
              <i className="ri-shield-user-line text-white text-2xl"></i>
            </div>
            <h1 className="text-2xl font-bold text-gray-900 mb-2">管理员登录</h1>
            <p className="text-gray-600">请输入管理员账号密码</p>
          </div>

          <form onSubmit={handleLogin} className="space-y-6">
            <Input
              label="用户名"
              type="text"
              value={loginForm.username}
              onChange={(e) => setLoginForm({ ...loginForm, username: e.target.value })}
              placeholder="请输入用户名"
              required
            />
            <Input
              label="密码"
              type="password"
              value={loginForm.password}
              onChange={(e) => setLoginForm({ ...loginForm, password: e.target.value })}
              placeholder="请输入密码"
              required
            />
            <Button type="submit" variant="primary" className="w-full whitespace-nowrap" disabled={loading}>
              {loading ? (
                <>
                  <i className="ri-loader-4-line animate-spin mr-2"></i>
                  登录中...
                </>
              ) : (
                '登录'
              )}
            </Button>
          </form>

          <div className="mt-6 text-center text-sm text-gray-500">
            请使用管理员账号登录
          </div>
        </Card>
      </div>
    );
  }

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center" style={{background: 'linear-gradient(135deg, #64748b, #cbd5e1)'}}>
        <Card className="p-8 text-center" glass>
          <div className="w-16 h-16 bg-gradient-to-r from-blue-500 to-purple-500 rounded-full flex items-center justify-center mx-auto mb-4">
            <i className="ri-loader-4-line animate-spin text-white text-2xl"></i>
          </div>
          <h2 className="text-xl font-bold text-gray-900 mb-2">加载中...</h2>
          <p className="text-gray-600">正在从 Supabase 云端加载数据</p>
        </Card>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-100 via-white to-slate-200">
      <Navbar />
      
      {/* 状态提示 */}
      {saveStatus && (
        <div className="fixed top-20 right-4 bg-green-100 border border-green-400 text-green-700 px-4 py-2 rounded-lg shadow-lg z-50">
          <div className="flex items-center space-x-2">
            <i className="ri-check-line"></i>
            <span className="text-sm">{saveStatus}</span>
          </div>
        </div>
      )}
      <div className="pt-20 pb-12">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          {/* Header */}
          <div className="flex justify-between items-center mb-8">
            <div>
              <h1 className="text-3xl font-bold text-gray-900">Yating Qiu</h1>
              <p className="text-gray-600 mt-2">Log in</p>

              {/* 保存状态指示器 */}
              <div className="mt-3 flex items-center space-x-4">
                {saveStatus === 'saving' && (
                  <div className="flex items-center text-blue-600">
                    <i className="ri-loader-4-line animate-spin mr-2"></i>
                    <span className="text-sm">正在保存到 Supabase 云端...</span>
                  </div>
                )}
                {saveStatus === 'success' && (
                  <div className="flex items-center text-green-600">
                    <i className="ri-check-line mr-2"></i>
                    <span className="text-sm">已成功保存到 Supabase 云端</span>
                  </div>
                )}
                {saveStatus === 'error' && (
                  <div className="flex items-center text-red-600">
                    <i className="ri-error-warning-line mr-2"></i>
                    <span className="text-sm">云端保存失败，已保存到本地</span>
                  </div>
                )}

                {/* Supabase 连接状态 */}
                <div className="flex items-center text-gray-500">
                  <div className="w-2 h-2 bg-green-500 rounded-full mr-2 animate-pulse"></div>
                  <span className="text-xs">Supabase 云端已连接</span>
                </div>
              </div>
            </div>
            <Button onClick={handleLogout} variant="outline" className="whitespace-nowrap">
              <i className="ri-logout-box-line mr-2"></i>
              退出登录
            </Button>
          </div>

          {/* Tabs */}
          <div className="flex space-x-1 mb-8 bg-white/50 p-1 rounded-xl overflow-x-auto">
            {tabs.map((tab) => (
              <button
                key={tab.id}
                onClick={() => setActiveTab(tab.id)}
                className={`flex items-center justify-center space-x-2 py-3 px-4 rounded-lg transition-all duration-200 whitespace-nowrap cursor-pointer ${
                  activeTab === tab.id
                    ? 'bg-white shadow-md text-blue-600'
                    : 'text-gray-600 hover:text-gray-900'
                }`}
              >
                <i className={tab.icon}></i>
                <span className="font-medium">{tab.name}</span>
              </button>
            ))}
          </div>

          {/* Content */}
          <div className="space-y-6">
            {/* Personal Information */}
            {activeTab === 'personal' && (
              <Card className="p-6" glass>
                <div className="flex justify-between items-center mb-6">
                  <h2 className="text-xl font-bold text-gray-900">个人信息管理</h2>
                  <Button onClick={handleEditPersonalInfo} variant="primary" className="whitespace-nowrap">
                    <i className="ri-edit-line mr-2"></i>
                    编辑信息
                  </Button>
                </div>

                <div className="grid md:grid-cols-1 gap-6">
                  {/* 基本信息区域 */}
                  <div className="grid md:grid-cols-2 gap-6">
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-2">姓名</label>
                      <p className="text-gray-900">{adminData.personalInfo.name}</p>
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-2">职位</label>
                      <p className="text-gray-900">{adminData.personalInfo.title}</p>
                    </div>
                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-2">邮箱</label>
                      <p className="text-gray-900">{adminData.personalInfo.email}</p>
                    </div>
                    <div className="md:col-span-2">
                      <label className="block text-sm font-medium text-gray-700 mb-2">地址</label>
                      <p className="text-gray-900">{adminData.personalInfo.location}</p>
                    </div>
                  </div>
                </div>

                <div className="mt-6 space-y-6">
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">个人简介</label>
                    <p className="text-gray-900 leading-relaxed">{adminData.personalInfo.summary}</p>
                  </div>
                </div>
              </Card>
            )}

            {/* 主页底部展示图片管理 - 独立的卡片 */}
            {activeTab === 'personal' && (
              <Card className="p-6 mt-6 border-2 border-dashed border-orange-200 bg-orange-50/30" glass>
                <div className="flex justify-between items-center mb-6">
                  <div>
                    <h2 className="text-xl font-bold text-gray-900 flex items-center">
                      <i className="ri-image-2-line mr-2 text-orange-600"></i>
                      主页底部展示图片管理
                    </h2>
                    <p className="text-sm text-orange-700 mt-1">
                      <i className="ri-alert-line mr-1"></i>
                      注意：这里管理的是主页底部展示的图片，与上方的个人头像完全独立
                    </p>
                  </div>
                  <div className="flex items-center space-x-2">
                    <input
                      type="file"
                      accept="image/*"
                      multiple
                      onChange={(e) => {
                        if (e.target.files) {
                          handleHomeImageUpload(e.target.files);
                        }
                      }}
                      className="hidden"
                      id="home-images-upload"
                    />
                    <label htmlFor="home-images-upload" className="inline-flex items-center px-4 py-2 bg-orange-600 text-white rounded-lg hover:bg-orange-700 transition-colors cursor-pointer text-sm whitespace-nowrap">
                      <i className="ri-upload-line mr-2"></i>
                      上传主页图片
                    </label>
                  </div>
                </div>

                {/* 图片展示网格 */}
                <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
                  {adminData.homeImages?.map((image: string, index: number) => (
                    <div key={index} className="relative group">
                      <img src={image} alt={`主页底部图片 ${index + 1}`} className="w-full h-32 object-cover object-top rounded-lg border-2 border-orange-200" />
                      <button
                        onClick={() => handleDeleteHomeImage(index)}
                        className="absolute top-2 right-2 p-1 bg-red-600 text-white rounded-full opacity-0 group-hover:opacity-100 transition-opacity cursor-pointer"
                      >
                        <i className="ri-close-line text-sm"></i>
                      </button>
                      <div className="absolute bottom-2 left-2 bg-black/50 text-white text-xs px-2 py-1 rounded">主页图片 {index + 1}</div>
                    </div>
                  ))}

                  {/* 如果没有图片，显示提示 */}
                  {(!adminData.homeImages || adminData.homeImages.length === 0) && (
                    <div className="col-span-full text-center py-12 text-orange-600 bg-white/50 rounded-lg border-2 border-dashed border-orange-300">
                      <i className="ri-image-add-line text-6xl mb-4"></i>
                      <h3 className="text-lg font-medium mb-2">暂无主页底部展示图片</h3>
                      <p className="text-sm mb-1">点击"上传主页图片"按钮添加图片</p>
                      <p className="text-xs text-orange-500">这些图片将在主页底部的"关于我"部分展示</p>
                    </div>
                  )}
                </div>

                <div className="mt-4 p-3 bg-orange-100 rounded-lg">
                  <p className="text-xs text-orange-800 flex items-start">
                    <i className="ri-information-line mr-2 mt-0.5 flex-shrink-0"></i>
                    <span>
                      <strong>功能说明：</strong>
                      <br />
                      • 支持 JPG、PNG 格式，最大 5MB
                      <br />
                      • 图片会自动保存到 Supabase 云端，确保数据安全
                      <br />
                      • 这些图片专门用于主页底部展示，丰富页面内容
                      <br />
                      • 与个人头像管理完全独立，互不影响
                    </span>
                  </p>
                </div>
              </Card>
            )}

            {/* Education */}
            {activeTab === 'education' && (
              <Card className="p-6" glass>
                <div className="flex justify-between items-center mb-6">
                  <h2 className="text-xl font-bold text-gray-900">Honor管理</h2>
                  <Button onClick={() => handleEditEducation()} variant="primary" className="whitespace-nowrap">
                    <i className="ri-add-line mr-2"></i>
                    添加Honor
                  </Button>
                </div>
                <div className="space-y-4">
                  {adminData.education?.map((item) => (
                    <div key={item.id} className="border border-gray-200 rounded-lg p-4 hover:shadow-md transition-shadow">
                      <div className="flex justify-between items-start">
                        <div className="flex-1">
                          <h3 className="font-semibold text-gray-900">{item.school}</h3>
                          <p className="text-gray-600">
                            {item.major} - {item.degree}
                          </p>
                          <p className="text-sm text-gray-500">{item.startDate} - {item.endDate}</p>
                          {item.gpa && <p className="text-sm text-gray-500">GPA: {item.gpa}</p>}
                          {item.image && (
                            <div className="mt-2">
                              <p className="text-gray-600 text-sm mb-1">配图：</p>
                              <img src={item.image} alt={item.school} className="w-32 h-24 object-cover object-top rounded-lg border" />
                            </div>
                          )}
                          <p className="text-sm text-gray-700 mt-2">{item.description}</p>
                        </div>
                        <div className="flex space-x-2 ml-4">
                          <button onClick={() => handleEditEducation(item)} className="p-2 text-blue-600 hover:bg-blue-50 rounded-lg cursor-pointer">
                            <i className="ri-edit-line"></i>
                          </button>
                          <button onClick={() => handleDelete('education', item.id)} className="p-2 text-red-600 hover:bg-red-50 rounded-lg cursor-pointer">
                            <i className="ri-delete-bin-line"></i>
                          </button>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </Card>
            )}

            {/* Experience */}
            {activeTab === 'experience' && (
              <Card className="p-6" glass>
                <div className="flex justify-between items-center mb-6">
                  <h2 className="text-xl font-bold text-gray-900">Experience管理</h2>
                  <Button onClick={() => handleEditExperience()} variant="primary" className="whitespace-nowrap">
                    <i className="ri-add-line mr-2"></i>
                    添加Experience
                  </Button>
                </div>
                <div className="space-y-4">
                  {adminData.experience?.map((item) => (
                    <div key={item.id} className="border border-gray-200 rounded-lg p-4 hover:shadow-md transition-shadow">
                      <div className="flex justify-between items-start">
                        <div className="flex-1">
                          <h3 className="font-semibold text-gray-900">{item.company}</h3>
                          <p className="text-gray-600">{item.position}</p>
                          <p className="text-sm text-gray-500">{item.startDate} - {item.endDate}</p>
                          {item.image && (
                            <div className="mt-2">
                              <p className="text-gray-600 text-sm mb-1">配图：</p>
                              <img src={item.image} alt={item.company} className="w-32 h-24 object-cover object-top rounded-lg border" />
                            </div>
                          )}
                          <p className="text-sm text-gray-700 mt-2">{item.description}</p>
                          {item.achievements && item.achievements.length > 0 && (
                            <div className="mt-2">
                              <p className="text-sm font-medium text-gray-700">主要成就：</p>
                              <ul className="text-sm text-gray-600 list-disc list-inside">
                                {item.achievements?.map((achievement, index) => (
                                  <li key={index}>{achievement}</li>
                                ))}
                              </ul>
                            </div>
                          )}
                        </div>
                        <div className="flex space-x-2 ml-4">
                          <button onClick={() => handleEditExperience(item)} className="p-2 text-blue-600 hover:bg-blue-50 rounded-lg cursor-pointer">
                            <i className="ri-edit-line"></i>
                          </button>
                          <button onClick={() => handleDelete('experience', item.id)} className="p-2 text-red-600 hover:bg-red-50 rounded-lg cursor-pointer">
                            <i className="ri-delete-bin-line"></i>
                          </button>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </Card>
            )}

            {/* Projects */}
            {activeTab === 'projects' && (
              <Card className="p-6" glass>
                <div className="flex justify-between items-center mb-6">
                  <h2 className="text-xl font-bold text-gray-900">项目作品管理</h2>
                  <Button onClick={() => handleEditProject()} variant="primary" className="whitespace-nowrap">
                    <i className="ri-add-line mr-2"></i>
                    添加项目
                  </Button>
                </div>
                <div className="grid md:grid-cols-2 gap-6">
                  {adminData.projects?.map((item) => (
                    <div key={item.id} className="border border-gray-200 rounded-lg p-4 hover:shadow-md transition-shadow">
                      <div className="flex justify-between items-start mb-3">
                        <h3 className="font-semibold text-gray-900 flex-1">{item.name}</h3>
                        <div className="flex space-x-1 ml-2">
                          <button onClick={() => handleEditProject(item)} className="p-1 text-blue-600 hover:bg-blue-50 rounded cursor-pointer">
                            <i className="ri-edit-line text-sm"></i>
                          </button>
                          <button onClick={() => handleDelete('project', item.id)} className="p-1 text-red-600 hover:bg-red-50 rounded cursor-pointer">
                            <i className="ri-delete-bin-line text-sm"></i>
                          </button>
                        </div>
                      </div>
                      {item.image && (
                        <div className="mb-2">
                          <img src={item.image} alt={item.name} className="w-full h-32 object-cover object-top rounded-lg border" />
                        </div>
                      )}
                      <p className="text-sm text-gray-700 mb-2">{item.description}</p>
                      <p className="text-xs text-gray-500 mb-2">{item.startDate} - {item.endDate}</p>
                      <div className="flex flex-wrap gap-1 mb-2">
                        {item.technologies?.map((tech, index) => (
                          <span key={index} className="px-2 py-1 bg-green-100 text-green-800 rounded text-xs">
                            {tech}
                          </span>
                        ))}
                      </div>
                      {item.github && <p className="text-xs text-blue-600">GitHub: {item.github}</p>}
                    </div>
                  ))}
                </div>
              </Card>
            )}

            {/* Papers */}
            {activeTab === 'papers' && (
              <Card className="p-6" glass>
                <div className="flex justify-between items-center mb-6">
                  <h2 className="text-xl font-bold text-gray-900">学术成果管理</h2>
                  <Button onClick={() => handleEditPaper()} variant="primary" className="whitespace-nowrap">
                    <i className="ri-add-line mr-2"></i>
                    添加学术成果
                  </Button>
                </div>
                <div className="space-y-4">
                  {adminData.papers?.map((item) => (
                    <div key={item.id} className="border border-gray-200 rounded-lg p-4 hover:shadow-md transition-shadow">
                      <div className="flex justify-between items-start">
                        <div className="flex-1">
                          <h3 className="font-semibold text-gray-900 mb-2">{item.title}</h3>
                          <p className="text-gray-600 text-sm mb-1">
                            发表于《{item.journal}》{item.date}
                          </p>
                          <p className="text-gray-600 text-sm mb-2">作者：{item.authors}</p>
                          {item.url && (
                            <p className="text-blue-600 text-sm mb-2">
                              <i className="ri-link mr-1"></i>
                              链接：{item.url}
                            </p>
                          )}
                          {item.image && (
                            <div className="mb-2">
                              <p className="text-gray-600 text-sm mb-1">论文配图：</p>
                              <img src={item.image} alt={item.title} className="w-32 h-24 object-cover object-top rounded-lg border" />
                            </div>
                          )}
                          <p className="text-sm text-gray-700 mb-2">{item.abstract}</p>
                          <div className="flex flex-wrap gap-1">
                            {item.keywords?.map((keyword, index) => (
                              <span key={index} className="px-2 py-1 bg-purple-100 text-purple-800 rounded text-xs">
                                {keyword}
                              </span>
                            ))}
                          </div>
                        </div>
                        <div className="flex space-x-2 ml-4">
                          <button onClick={() => handleEditPaper(item)} className="p-2 text-blue-600 hover:bg-blue-50 rounded-lg cursor-pointer">
                            <i className="ri-edit-line"></i>
                          </button>
                          <button onClick={() => handleDelete('paper', item.id)} className="p-2 text-red-600 hover:bg-red-50 rounded-lg cursor-pointer">
                            <i className="ri-delete-bin-line"></i>
                          </button>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </Card>
            )}
          </div>
        </div>
      </div>

      {/* Modal */}
      <Modal isOpen={showModal} onClose={() => setShowModal(false)} title={`编辑${editingType === 'personal' ? '个人信息' : editingType === 'education' ? 'Honor' : editingType === 'experience' ? 'Experience' : editingType === 'project' ? '项目作品' : '学术成果'}`}>
        <div className="space-y-4 max-h-96 overflow-y-auto">
          {/* Personal Info Editing */}
          {editingType === 'personal' && editingItem && (
            <>
              <Input label="姓名" value={editingItem.name || ''} onChange={(e) => setEditingItem({ ...editingItem, name: e.target.value })} placeholder="请输入姓名" />
              <Input label="职位" value={editingItem.title || ''} onChange={(e) => setEditingItem({ ...editingItem, title: e.target.value })} placeholder="请输入职位" />
              <Input label="邮箱" value={editingItem.email || ''} onChange={(e) => setEditingItem({ ...editingItem, email: e.target.value })} placeholder="请输入邮箱" />
              <Input label="地址" value={editingItem.location || ''} onChange={(e) => setEditingItem({ ...editingItem, location: e.target.value })} placeholder="请输入地址" />

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">个人简介</label>
                <textarea
                  value={editingItem.summary || ''}
                  onChange={(e) => setEditingItem({ ...editingItem, summary: e.target.value })}
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                  rows={4}
                  placeholder="请输入个人简介"
                />
              </div>
            </>
          )}

          {/* Education Editing */}
          {editingType === 'education' && editingItem && (
            <>
              <Input label="学校名称" value={editingItem.school || ''} onChange={(e) => setEditingItem({ ...editingItem, school: e.target.value })} placeholder="请输入学校名称" />
              <Input label="学位" value={editingItem.degree || ''} onChange={(e) => setEditingItem({ ...editingItem, degree: e.target.value })} placeholder="请输入学位" />
              <Input label="专业" value={editingItem.major || ''} onChange={(e) => setEditingItem({ ...editingItem, major: e.target.value })} placeholder="请输入专业" />
              <div className="grid grid-cols-2 gap-4">
                <Input label="开始时间" type="month" value={editingItem.startDate || ''} onChange={(e) => setEditingItem({ ...editingItem, startDate: e.target.value })} />
                <Input label="结束时间" type="month" value={editingItem.endDate || ''} onChange={(e) => setEditingItem({ ...editingItem, endDate: e.target.value })} />
              </div>
              <Input label="GPA (可选)" value={editingItem.gpa || ''} onChange={(e) => setEditingItem({ ...editingItem, gpa: e.target.value })} placeholder="请输入GPA" />
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">描述</label>
                <textarea
                  value={editingItem.description || ''}
                  onChange={(e) => setEditingItem({ ...editingItem, description: e.target.value })}
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                  rows={3}
                  placeholder="请输入教育经历描述"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">配图 (可选)</label>
                <input
                  type="file"
                  accept="image/*"
                  onChange={(e) => {
                    const file = e.target.files?.[0];
                    if (file) {
                      if (file.size > 5 * 1024 * 1024) {
                        alert('图片大小不能超过5MB');
                        return;
                      }
                      void handleEditorImageUpload(file);
                    }
                  }}
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                />
                {editingItem.image && (
                  <div className="mt-2">
                    <img src={editingItem.image} alt="预览" className="w-32 h-24 object-cover object-top rounded border" />
                  </div>
                )}
              </div>
            </>
          )}

          {/* Experience Editing */}
          {editingType === 'experience' && editingItem && (
            <>
              <Input label="公司名称" value={editingItem.company || ''} onChange={(e) => setEditingItem({ ...editingItem, company: e.target.value })} placeholder="请输入公司名称" />
              <Input label="职位" value={editingItem.position || ''} onChange={(e) => setEditingItem({ ...editingItem, position: e.target.value })} placeholder="请输入职位" />
              <div className="grid grid-cols-2 gap-4">
                <Input label="开始时间" type="month" value={editingItem.startDate || ''} onChange={(e) => setEditingItem({ ...editingItem, startDate: e.target.value })} />
                <Input label="结束时间" type="month" value={editingItem.endDate || ''} onChange={(e) => setEditingItem({ ...editingItem, endDate: e.target.value })} />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">工作描述</label>
                <textarea
                  value={editingItem.description || ''}
                  onChange={(e) => setEditingItem({ ...editingItem, description: e.target.value })}
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-5  0 focus:border-transparent"
                  rows={3}
                  placeholder="请输入工作描述"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">主要成就</label>
                {editingItem.achievements?.map((achievement: string, index: number) => (
                  <div key={index} className="flex items-center space-x-2 mb-2">
                    <input
                      type="text"
                      value={achievement}
                      onChange={(e) => {
                        const newAchievements = [...(editingItem.achievements || [])];
                        newAchievements[index] = e.target.value;
                        setEditingItem({ ...editingItem, achievements: newAchievements });
                      }}
                      className="flex-1 px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                      placeholder={`成就 ${index + 1}`}
                    />
                    <button
                      type="button"
                      onClick={() => {
                        const newAchievements = editingItem.achievements?.filter((_: any, i: number) => i !== index) || [];
                        setEditingItem({ ...editingItem, achievements: newAchievements });
                      }}
                      className="p-2 text-red-600 hover:bg-red-50 rounded cursor-pointer"
                    >
                      <i className="ri-delete-bin-line"></i>
                    </button>
                  </div>
                ))}
                <button
                  type="button"
                  onClick={() => {
                    const newAchievements = [...(editingItem.achievements || []), ''];
                    setEditingItem({ ...editingItem, achievements: newAchievements });
                  }}
                  className="text-blue-600 hover:text-blue-800 text-sm cursor-pointer"
                >
                  + 添加成就
                </button>
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">配图 (可选)</label>
                <input
                  type="file"
                  accept="image/*"
                  onChange={(e) => {
                    const file = e.target.files?.[0];
                    if (file) {
                      if (file.size > 5 * 1024 * 1024) {
                        alert('图片大小不能超过5MB');
                        return;
                      }
                      void handleEditorImageUpload(file);
                    }
                  }}
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                />
                {editingItem.image && (
                  <div className="mt-2">
                    <img src={editingItem.image} alt="预览" className="w-32 h-24 object-cover object-top rounded border" />
                  </div>
                )}
              </div>
            </>
          )}

          {/* Project Editing */}
          {editingType === 'project' && editingItem && (
            <>
              <Input label="项目名称" value={editingItem.name || ''} onChange={(e) => setEditingItem({ ...editingItem, name: e.target.value })} placeholder="请输入项目名称" />
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">项目描述</label>
                <textarea
                  value={editingItem.description || ''}
                  onChange={(e) => setEditingItem({ ...editingItem, description: e.target.value })}
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-5  0 focus:border-transparent"
                  rows={3}
                  placeholder="请输入项目描述"
                />
              </div>
              <div className="grid grid-cols-2 gap-4">
                <Input label="开始时间" type="month" value={editingItem.startDate || ''} onChange={(e) => setEditingItem({ ...editingItem, startDate: e.target.value })} />
                <Input label="结束时间" type="month" value={editingItem.endDate || ''} onChange={(e) => setEditingItem({ ...editingItem, endDate: e.target.value })} />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">技术栈</label>
                {editingItem.technologies?.map((tech: string, index: number) => (
                  <div key={index} className="flex items-center space-x-2 mb-2">
                    <input
                      type="text"
                      value={tech}
                      onChange={(e) => {
                        const newTechnologies = [...(editingItem.technologies || [])];
                        newTechnologies[index] = e.target.value;
                        setEditingItem({ ...editingItem, technologies: newTechnologies });
                      }}
                      className="flex-1 px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-5  0 focus:border-transparent"
                      placeholder={`技术 ${index + 1}`}
                    />
                    <button
                      type="button"
                      onClick={() => {
                        const newTechnologies = editingItem.technologies?.filter((_: any, i: number) => i !== index) || [];
                        setEditingItem({ ...editingItem, technologies: newTechnologies });
                      }}
                      className="p-2 text-red-600 hover:bg-red-50 rounded cursor-pointer"
                    >
                      <i className="ri-delete-bin-line"></i>
                    </button>
                  </div>
                ))}
                <button
                  type="button"
                  onClick={() => {
                    const newTechnologies = [...(editingItem.technologies || []), ''];
                    setEditingItem({ ...editingItem, technologies: newTechnologies });
                  }}
                  className="text-blue-600 hover:text-blue-800 text-sm cursor-pointer"
                >
                  + 添加技术
                </button>
              </div>
              <Input label="GitHub链接 (可选)" value={editingItem.github || ''} onChange={(e) => setEditingItem({ ...editingItem, github: e.target.value })} placeholder="请输入GitHub链接" />
              <Input label="演示链接 (可选)" value={editingItem.demo || ''} onChange={(e) => setEditingItem({ ...editingItem, demo: e.target.value })} placeholder="请输入演示链接" />
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">项目亮点</label>
                {editingItem.highlights?.map((highlight: string, index: number) => (
                  <div key={index} className="flex items-center space-x-2 mb-2">
                    <input
                      type="text"
                      value={highlight}
                      onChange={(e) => {
                        const newHighlights = [...(editingItem.highlights || [])];
                        newHighlights[index] = e.target.value;
                        setEditingItem({ ...editingItem, highlights: newHighlights });
                      }}
                      className="flex-1 px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-5  0 focus:border-transparent"
                      placeholder={`亮点 ${index + 1}`}
                    />
                    <button
                      type="button"
                      onClick={() => {
                        const newHighlights = editingItem.highlights?.filter((_: any, i: number) => i !== index) || [];
                        setEditingItem({ ...editingItem, highlights: newHighlights });
                      }}
                      className="p-2 text-red-600 hover:bg-red-50 rounded cursor-pointer"
                    >
                      <i className="ri-delete-bin-line"></i>
                    </button>
                  </div>
                ))}
                <button
                  type="button"
                  onClick={() => {
                    const newHighlights = [...(editingItem.highlights || []), ''];
                    setEditingItem({ ...editingItem, highlights: newHighlights });
                  }}
                  className="text-blue-600 hover:text-blue-800 text-sm cursor-pointer"
                >
                  + 添加亮点
                </button>
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">项目配图 (可选)</label>
                <input
                  type="file"
                  accept="image/*"
                  onChange={(e) => {
                    const file = e.target.files?.[0];
                    if (file) {
                      if (file.size > 5 * 1024 * 1024) {
                        alert('图片大小不能超过5MB');
                        return;
                      }
                      void handleEditorImageUpload(file);
                    }
                  }}
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-5  0 focus:border-transparent"
                />
                {editingItem.image && (
                  <div className="mt-2">
                    <img src={editingItem.image} alt="预览" className="w-full h-32 object-cover object-top rounded border" />
                  </div>
                )}
              </div>
            </>
          )}

          {/* Paper Editing */}
          {editingType === 'paper' && editingItem && (
            <>
              <Input label="论文标题" value={editingItem.title || ''} onChange={(e) => setEditingItem({ ...editingItem, title: e.target.value })} placeholder="请输入论文标题" />
              <Input label="发表期刊/会议" value={editingItem.journal || ''} onChange={(e) => setEditingItem({ ...editingItem, journal: e.target.value })} placeholder="请输入发表期刊或会议" />
              <Input label="发表日期" type="month" value={editingItem.date || ''} onChange={(e) => setEditingItem({ ...editingItem, date: e.target.value })} />
              <Input label="作者" value={editingItem.authors || ''} onChange={(e) => setEditingItem({ ...editingItem, authors: e.target.value })} placeholder="请输入作者信息" />
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">摘要</label>
                <textarea
                  value={editingItem.abstract || ''}
                  onChange={(e) => setEditingItem({ ...editingItem, abstract: e.target.value })}
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-5  0 focus:border-transparent"
                  rows={4}
                  placeholder="请输入论文摘要"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">关键词</label>
                {editingItem.keywords?.map((keyword: string, index: number) => (
                  <div key={index} className="flex items-center space-x-2 mb-2">
                    <input
                      type="text"
                      value={keyword}
                      onChange={(e) => {
                        const newKeywords = [...(editingItem.keywords || [])];
                        newKeywords[index] = e.target.value;
                        setEditingItem({ ...editingItem, keywords: newKeywords });
                      }}
                      className="flex-1 px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-5  0 focus:border-transparent"
                      placeholder={`关键词 ${index + 1}`}
                    />
                    <button
                      type="button"
                      onClick={() => {
                        const newKeywords = editingItem.keywords?.filter((_: any, i: number) => i !== index) || [];
                        setEditingItem({ ...editingItem, keywords: newKeywords });
                      }}
                      className="p-2 text-red-600 hover:bg-red-50 rounded cursor-pointer"
                    >
                      <i className="ri-delete-bin-line"></i>
                    </button>
                  </div>
                ))}
                <button
                  type="button"
                  onClick={() => {
                    const newKeywords = [...(editingItem.keywords || []), ''];
                    setEditingItem({ ...editingItem, keywords: newKeywords });
                  }}
                  className="text-blue-600 hover:text-blue-800 text-sm cursor-pointer"
                >
                  + 添加关键词
                </button>
              </div>
              <Input label="论文链接 (可选)" value={editingItem.url || ''} onChange={(e) => setEditingItem({ ...editingItem, url: e.target.value })} placeholder="请输入论文链接" />
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">论文配图 (可选)</label>
                <input
                  type="file"
                  accept="image/*"
                  onChange={(e) => {
                    const file = e.target.files?.[0];
                    if (file) {
                      if (file.size > 5 * 1024 * 1024) {
                        alert('图片大小不能超过5MB');
                        return;
                      }
                      void handleEditorImageUpload(file);
                    }
                  }}
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-5  0 focus:border-transparent"
                />
                {editingItem.image && (
                  <div className="mt-2">
                    <img src={editingItem.image} alt="预览" className="w-32 h-24 object-cover object-top rounded border" />
                  </div>
                )}
              </div>
            </>
          )}

          <div className="flex justify-end space-x-3 pt-4 border-t">
            <Button onClick={() => setShowModal(false)} variant="outline" className="whitespace-nowrap">
              取消
            </Button>
            <Button onClick={handleSave} variant="primary" className="whitespace-nowrap" disabled={saveStatus === 'saving'}>
              {saveStatus === 'saving' ? (
                <>
                  <i className="ri-loader-4-line animate-spin mr-2"></i>
                  保存中...
                </>
              ) : (
                '保存'
              )}
            </Button>
          </div>
        </div>
      </Modal>
    </div>
  );
}
